import React, { useContext, useEffect, useState } from "react";
import ObjectTableRows from "./ObjectTableRows";
import {
	useGetAllUsersQuery,
	useGetSpecificUserQuery,
} from "../../../../Redux/service/Users/Users";
import { filtrationcontext } from "../../../../context/Filtercontext";
import Loader from "../../../Helpers/Loader/Loader";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useGetAllGroupsQuery } from "../../../../Redux/service/Groups/Groups";
import trans from "../../../../utils";

export default function ObjectTableBodyGroups({ type }) {
	const [imei, setImei] = useState(null);

	const [openDropdowns, setOpenDropdowns] = useState([]);
	const [shownData, setShownData] = useState([]);
	const [userDevices, setUserDevices] = useState([]);
	const {
		filter,
		isFilterTriggered,
		setIsFilterTriggered,
		ObjectsearchQuery,
		parentCheck,
		childCheck,
	} = useContext(filtrationcontext);

	let { pathname } = useLocation();
	const inf = useSelector((state) => state.users.user);
	const { data: UserInf, isLoading: userLoading } = useGetSpecificUserQuery(
		inf?.id
	);
	const toggleDropdown = (userId) => {
		setOpenDropdowns((prevOpenDropdowns) =>
			prevOpenDropdowns.includes(userId)
				? prevOpenDropdowns.filter((id) => id !== userId)
				: [...prevOpenDropdowns, userId]
		);
	};

	const { data: allUsers, isLoading: allUsersLoading } = useGetAllGroupsQuery({
		skip: pathname !== "/livetracking",
	});

	useEffect(() => {
		if (!filter && UserInf) {
			setShownData([UserInf]);
		}
	}, [UserInf, filter, allUsers]);

	useEffect(() => {
		if (!allUsers || !isFilterTriggered) return;
		let filteredData = [];
		if (filter) {
			filteredData = allUsers?.filter((user) => {
				const matchesFilter = parentCheck.includes(user.id);
				return matchesFilter;
			});
		}
		setShownData(filteredData); // Filter out undefined users
		setIsFilterTriggered(false);
	}, [
		UserInf,
		childCheck,
		allUsers,
		filter,
		parentCheck,
		ObjectsearchQuery,
		isFilterTriggered,
	]);

	const lang = localStorage.getItem("lang") || "en";

	if (userLoading || allUsersLoading) return <Loader />;
	if (!UserInf)
		return (
			<div className="my-5 p-5">
				<div className="text-center text-success fs-16 fw-700">
					{trans("No data shown")}
				</div>
			</div>
		);
	return (
		<>
			{pathname === "/livetracking" &&
				shownData.map((user) => (
					<div key={user?.id}>
						<div
							className="object-body-title"
							role="button"
							onClick={() => toggleDropdown(user?.id)}
						>
							<div className="d-flex">
								<div
									className="fs-14 fw-400 neutral-500 object-table-element"
									role="button"
								>
									<div className={user ? "fw-900" : ""}>
										{filter
											? user?.name
											: type === "vehicle"
											? trans("Ungrouped Vehicles")
											: trans("Ungrouped Devices")}
									</div>
								</div>
							</div>
							<div className={user ? "d-none" : ""}>
								<img
									src={
										openDropdowns.includes(user?.id)
											? `${process.env.PUBLIC_URL}/assets/Uparrow.svg`
											: `${process.env.PUBLIC_URL}/assets/Downarrow.svg`
									}
									alt="arrow"
								/>
							</div>
						</div>
						{
							<ObjectTableRows
								userid={user?.id}
								filter={filter}
								name={user?.name}
								userDevices={userDevices}
								setUserDevices={setUserDevices}
								setImei={setImei}
								imei={imei}
								type={type}
							/>
						}
					</div>
				))}

			{pathname === "/geofences" && (
				<div>
					<ObjectTableRows userid={inf?.id} setImei={setImei} />
				</div>
			)}
		</>
	);
}
